import { supplierApi } from '@/api/mall/product/supplierPortal'
import type { PropertyVO, PropertyValueVO } from '@/api/mall/product/property'

export const getPropertySimpleList = (): Promise<PropertyVO[]> => {
  return supplierApi.get({ url: '/supplier-api/product/property/simple-list' })
}

export const getPropertyValueSimpleList = (propertyId: number): Promise<PropertyValueVO[]> => {
  return supplierApi.get({
    url: '/supplier-api/product/property/value/simple-list',
    params: { propertyId }
  })
}
